import { createComponent } from '@mtfe/sweet';
import { common, container, dom, eventBus } from '@mtfe/sweet-utils';
import NewLoginModal from '../NewLoginModal/script';
import tpl from './dom.html';
import style from './style.less';

const { createUniqueId } = common;
const { isInWeixin, isInTuanApp, isMiniProgram } = container;
const searchBarIcon = createUniqueId();
const searchBarBtn = createUniqueId();
const searchBarLogin = createUniqueId();
const searchBarIptBox = createUniqueId();

const searchContent = style['search-content'];
const searchingContent = style['search-content-searching'];

const _getSearchBarDom = () => dom.$id('searchBar');
const _preventRemoveHandle = (e) => e.preventDefault();

/**
 * 禁止页面滚动
 */
const _scrollStop = () => {
    document.body.addEventListener('touchmove', _preventRemoveHandle, {
        passive: false,
    });
};

/**
 * 取消禁止页面滚动
 */
const _scrollStopRemove = () => {
    document.body.removeEventListener('touchmove', _preventRemoveHandle, {
        passive: false,
    });
};

/**
 * 获取搜索框内容
 * @returns {String}
 */
const getInputValue = () => {
    const inputDom = document.querySelector('#searchBar input[name="poi"]');
    const { value } = inputDom;
    return value.trim();
};
/**
 * 设置搜索框内容
 * @param {*} text 搜索框内容
 */
const setInputValue = (text) => {
    const inputDom = document.querySelector('#searchBar input[name="poi"]');
    inputDom.value = text;
};
/**
 * 隐藏搜索条
 */
const hideSearchBar = () => {
    _getSearchBarDom().style.display = 'none';
};

/**
 * 显示搜索条
 */
const showSearchBar = () => {
    _getSearchBarDom().style.display = '';
};

/**
 * 搜索条变为搜索状态
 */
const switchToSearch = () => {
    // 隐藏ICON
    dom.$id(searchBarIcon).style.display = 'none';
    // 显示搜索按钮
    dom.$id(searchBarBtn).style.display = 'flex';
    // 修改搜索框宽度
    dom.$id(searchBarIptBox).classList.replace(searchContent, searchingContent);
    // 隐藏登录信息
    dom.$id(searchBarLogin).style.display = 'none';
};

/**
 * 搜索条变为搜索结果状态
 */
const switchToResult = () => {
    if (getInputValue() === '') {
        return;
    }
    dom.$id(searchBarBtn).style.display = 'none';
};

/**
 * 搜索条变为默认状态
 */
const switchToIndex = () => {
    showSearchBar();
    // 显示CONN
    dom.$id(searchBarIcon).style.display = '';
    // 隐藏搜索按钮
    dom.$id(searchBarBtn).style.display = 'none';
    // 修改搜索框宽度
    dom.$id(searchBarIptBox).classList.replace(searchingContent, searchContent);
    // 显示登录信息
    dom.$id(searchBarLogin).style.display = '';
    // 删除输入框内容
    document.querySelector('#searchBar input[name="poi"]').value = '';
};

const SearchBarReady = () => {
    eventBus.$onceOn('SearchBarReady', () => {
        const inputDom = document.querySelector('input[name="poi"]');
        inputDom.addEventListener('focus', () => {
            _scrollStop();
        });
        inputDom.addEventListener('blur', () => {
            _scrollStopRemove();
        });
    });
};

const onceRegisterPopstate = once(
    (hideSearchBarRouter, searchBarDefaultRouter, searchBarSearchRouter, searchBarResultRouter) => {
        window.addEventListener(
            'popstate',
            function (e) {
                const hash = document.location.hash.replace('#', '') || 'index';
                if (hideSearchBarRouter.includes(hash)) {
                    hideSearchBar();
                } else {
                    showSearchBar();
                    if (searchBarDefaultRouter.includes(hash)) {
                        switchToIndex();
                        return;
                    }
                    if (searchBarSearchRouter.includes(hash)) {
                        switchToResult();
                        return;
                    }
                    if (searchBarResultRouter.includes(hash)) {
                        switchToResult();
                        return;
                    }
                }
            },
            false,
        );
    },
);

/**
 * 商家搜索登录条组件
 * @param {Object} props
 * @returns
 */
function SearchBar(props = {}) {
    /* eslint-enable */
    const {
        autoLogin,
        autoLoginProps,
        oadLX,
        loadLogin,
        hideSearchBarRouter = ['rule'],
        searchBarDefaultRouter = ['index'],
        searchBarSearchRouter = ['search'],
        searchBarResultRouter = ['result'],
    } = props;

    onceRegisterPopstate(
        hideSearchBarRouter,
        searchBarDefaultRouter,
        searchBarSearchRouter,
        searchBarResultRouter,
    );

    const { autoLoginOptions } = autoLoginProps;
    const { phone } = autoLoginOptions;
    const data = {
        phone,
        searchBarIcon,
        searchBarBtn,
        searchBarIptBox,
        searchBarLogin,
        hideChangeLogin: isInTuanApp || isMiniProgram,
    };
    const searchKeyWord = () => {
        const value = getInputValue();
        if (value === '') {
            return;
        }
        switchToResult();
        eventBus.$emit('click-search', value);
        if (window.location.hash !== '#result') {
            window.location.replace('#result');
        }
    };
    const events = {
        clickToSearchPage: () => {
            const cb = async () => {
                oadLX && oadLX.mc('b_waimai_sop6h9x0_mc');
                if (window.location.hash === '#result') {
                    window.location.replace('#search');
                }
                if (window.location.hash !== '#search') {
                    window.location.href = '#search';
                }
                document.querySelector('input[name="poi"]').focus();
                switchToSearch();
            };
            const autoLoginOptions = { cb, ...autoLoginProps.autoLoginOptions };
            const urlParams = autoLoginProps.urlParams;
            autoLogin(autoLoginOptions, urlParams);
        },
        clickToLogin: () => {
            const cb = () => {};
            const autoLoginOptions = { cb, ...autoLoginProps.autoLoginOptions };
            const urlParams = autoLoginProps.urlParams;
            autoLogin(autoLoginOptions, urlParams);
        },
        clickToReLogin: () => {
            const { loginSuccessCb } = autoLoginOptions;
            NewLoginModal({ loadLogin, loginSuccessCb });
        },
        clickToSearch: () => {
            searchKeyWord();
        },
        keyEnterDown: (event) => {
            if (event.keyCode === 13) {
                searchKeyWord();
            }
        },
    };
    // 对WX环境的单独处理
    if (isInWeixin && !isMiniProgram) {
        style['search-login'] = style['search-login-wx'];
    }
    SearchBarReady();
    return createComponent(tpl, { data, style }, events);
}

SearchBar.switchToIndex = switchToIndex;
SearchBar.switchToSearch = switchToSearch;
SearchBar.switchToResult = switchToResult;
SearchBar.getInputValue = getInputValue;
SearchBar.setInputValue = setInputValue;

/**
 * 注释
 * @param {*} fn
 * @returns
 */
function once(fn) {
    let called = false;
    return function _once() {
        if (called) {
            return _once.value;
        }
        called = true;
        _once.value = fn.apply(this, arguments);
    };
}
export default SearchBar;
